import React from 'react'
import Table from '../../compopnents/table/indx'

const AllResources = (props: any) => {

  return (
    <div>
      <Table type={'resources'} data={props.data}  pageSize={props.pageSize}/>
    </div>
  )
}

export default AllResources